import React from 'react';
import { ThemeProvider } from 'styled-components';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import GlobalStyles from './styles/GlobalStyles';
import Theme from './styles/Theme';
import { AffiliateThemeProvider } from './context/AffiliateThemeContext';
import './i18n/i18n';

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import { AffiliateLayout, PrivateRoute } from './components/affiliate';

// Pages
import HomePage from './pages/HomePage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import EulaPage from './pages/EulaPage';
import RgpdPage from './pages/RgpdPage';
import SupportPage from './pages/SupportPage';
import DeeplinkRedirect from './pages/DeeplinkRedirect';

// Affiliate Pages
import {
  AffiliateLandingPage,
  AffiliateSignupPage,
  AffiliateLoginPage,
  AffiliateDashboardPage,
  AffiliateTermsPage,
  AffiliateQRPage,
  AffiliateMarketingPage
} from './pages/affiliate';

// Composant pour les routes d'affiliation avec la mise en page spécifique
const AffiliateRoute = ({ element: Element, showHeader = true, showFooter = true }) => {
  return (
    <AffiliateLayout showHeader={showHeader} showFooter={showFooter}>
      <Element />
    </AffiliateLayout>
  );
};

function App() {
  return (
    <ThemeProvider theme={Theme}>
      <AffiliateThemeProvider>
        <GlobalStyles />
        <Router>
          <Routes>
          {/* Main Routes avec la navigation standard */}
          <Route 
            path="/" 
            element={
              <>
                <Navbar />
                <HomePage />
                <Footer />
              </>
            } 
          />
          <Route 
            path="/terms" 
            element={
              <>
                <Navbar />
                <TermsPage />
                <Footer />
              </>
            } 
          />
          <Route 
            path="/privacy" 
            element={
              <>
                <Navbar />
                <PrivacyPage />
                <Footer />
              </>
            } 
          />
          <Route 
            path="/eula" 
            element={
              <>
                <Navbar />
                <EulaPage />
                <Footer />
              </>
            } 
          />
          <Route 
            path="/rgpd" 
            element={
              <>
                <Navbar />
                <RgpdPage />
                <Footer />
              </>
            } 
          />
          <Route 
            path="/support" 
            element={
              <>
                <Navbar />
                <SupportPage />
                <Footer />
              </>
            } 
          />
          
          {/* Affiliate Routes avec la mise en page spécifique */}
          <Route path="/affiliate" element={<AffiliateRoute element={AffiliateLandingPage} />} />
          <Route path="/affiliate/signup" element={<AffiliateRoute element={AffiliateSignupPage} />} />
          <Route path="/affiliate/login" element={<AffiliateRoute element={AffiliateLoginPage} />} />
          <Route path="/affiliate/terms" element={<AffiliateRoute element={AffiliateTermsPage} />} />
          
          {/* Routes protégées qui nécessitent une authentification */}
          <Route path="/affiliate/dashboard" element={<PrivateRoute element={AffiliateDashboardPage} />} />
          <Route path="/affiliate/qrcode" element={<PrivateRoute element={AffiliateQRPage} />} />
          <Route path="/affiliate/marketing" element={<PrivateRoute element={AffiliateMarketingPage} />} />
          
          {/* Routes pour les deeplinks et redirections */}
          <Route path="/ref/:code" element={
            <>
              <Navbar />
              <DeeplinkRedirect />
              <Footer />
            </>
          } />
          <Route path="/download" element={
            <>
              <Navbar />
              <DeeplinkRedirect />
              <Footer />
            </>
          } />
          <Route path="/app/:type/:code" element={
            <>
              <Navbar />
              <DeeplinkRedirect />
              <Footer />
            </>
          } />
          <Route path="/app/:type" element={
            <>
              <Navbar />
              <DeeplinkRedirect />
              <Footer />
            </>
          } />
          
          {/* Redirection pour les routes non trouvées */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </Router>
      </AffiliateThemeProvider>
    </ThemeProvider>
  );
}

export default App;